import { render } from "./TeamLeadMultiselect.vue?vue&type=template&id=4587d000&ts=true"
import script from "./TeamLeadMultiselect.vue?vue&type=script&lang=ts"
export * from "./TeamLeadMultiselect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__